import React, { createContext, useContext, useState } from 'react';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const savedUser = localStorage.getItem('dexter_session');
    return savedUser ? JSON.parse(savedUser) : null;
  });

  const login = (username, password, rememberMe = false) => {
    const normalizedUsername = username.toLowerCase();
    
    let authenticatedUser = null;
    if (normalizedUsername === 'dextertarun' && password === 'HaRdIk321@#') {
      authenticatedUser = { role: 'admin', name: 'Dexter Admin (Tarun)', username: normalizedUsername };
    } else if (normalizedUsername === 'kovarandyork' && password === 'Kr321@') {
      authenticatedUser = { role: 'client', name: 'KovaRandYork (KR)', username: normalizedUsername };
    }

    if (authenticatedUser) {
      setUser(authenticatedUser);
      if (rememberMe) {
        localStorage.setItem('dexter_session', JSON.stringify(authenticatedUser));
      } else {
        localStorage.removeItem('dexter_session');
      }
      return true;
    }
    return false;
  };

  const logout = () => {
    localStorage.removeItem('dexter_session');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
